import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Index from "./components/Index";
import Login from "./components/Login";
import Register from "./components/register";
import Admin from "./components/admin";
import Home from "./components/Home";
import MyProfile from "./components/MyProfile";
import MyBookings from "./components/MyBookings";
import Reports from "./components/Reports";
import Bookings from "./components/bookings";
import Donations from "./components/Donations";
import About from "./components/About";
import Contact from "./components/Contact";
import ScrollToTop from "./components/ScrollToTop"
function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Index/>} />
        <Route path="/login" element={<Login/>} /> 
        <Route path="/register" element={<Register/>} /> 
        <Route path="/admin" element={<Admin/>} /> 
        <Route path="/Home" element={<Home/>} /> 
        <Route path="/about" element={<About/>} /> 
        <Route path="/contact" element={<Contact/>} /> 
        <Route path="/profile" element={<MyProfile/>} /> 
        <Route path="/booking" element={<Bookings/>} /> 
        <Route path="/donations" element={<Donations/>} /> 
        <Route path="/Mybooking" element={<MyBookings/>} /> 
        <Route path="/reports" element={<Reports/>} /> 
      </Routes>
    </Router>
  );
}

export default App;
